module.exports = __webpack_public_path__ + "zilla-slab-latin-700italic.d2dd37a032a1efe8a89944ed47fde76d.woff";